import apiManager from '../../api/api-manager';
import { genericApiError, isAxiosResponseOk } from '../../api/api-common';
import { env } from '../../env';
import {PostMifidExternalMassiveRequest, SurveyRisposte} from "../../api/generated/dob";
import {getAPIRequestHeaders} from "../../utils/api-utils";

class MifidSurveyRepository {
  getMifidSurvey = async (customerCode: string) => {
    const response =
      await apiManager.prometeiaCustomersApi.getQuestionnaireMifid(
        env.prometeiaTenantId,
        customerCode,
        env.prometeiaSourceCode,
        env.prometeiaLanguageRequest
      );

    if (!isAxiosResponseOk(response)) {
      return genericApiError();
    } else {
      return response.data;
    }
  };

  getMifidThematicSurvey = async () => {
    const response = await apiManager.dobSurveyApi.getTemplateExternal(
      'MIFID_PF',
    );

    if (!isAxiosResponseOk(response)) {
      return genericApiError();
    } else {
      return response.data;
    }
  };

  writeMifidSurvey = async (
    customercode: string,
    writeQuestionnaireMifidRequest: PostMifidExternalMassiveRequest,
    thunkApi
  ) => {
    const response =
      await apiManager.dobSurveyApi.postMifidExternalMassive(
        customercode,
        writeQuestionnaireMifidRequest,
        getAPIRequestHeaders(thunkApi)
      );

    if (!isAxiosResponseOk(response)) {
      return genericApiError();
    } else {
      return response.data;
    }
  };

  writeMifidNoProfiling = async (
    surveyAnswers: SurveyRisposte,
    thunkApi
  ) => {
    const response = 
      await apiManager.dobSurveyApi.postMifidNoProfiling(surveyAnswers, getAPIRequestHeaders(thunkApi));
      if (!isAxiosResponseOk(response)) {
        return genericApiError();
      } else {
        return response.data;
      }
  }

  getMifidImage = async (imageKey: string, thunkApi) => {
    const response = await apiManager.dobSurveyApi.getImages(imageKey, getAPIRequestHeaders(thunkApi));
    if (!isAxiosResponseOk(response)) {
      return genericApiError();
    } else {
      return "data:image/jpeg;base64," + response.data;
    }
  };

  registerMifid = async (codiceMifid: string | undefined, thunkApi) => {
    const response = await apiManager.mifidApi.registraMifid({codiceMifid: codiceMifid},getAPIRequestHeaders(thunkApi))
    if (!isAxiosResponseOk(response)){
      return genericApiError();
    } else {
      return true;
    }
  }
}

const mifidSurveyRepository = new MifidSurveyRepository();
export default mifidSurveyRepository;
